import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { api, resolveImage, formatApiErrorDetail } from "@/lib/api";

const ImageUpload = ({ value, onChange, testId = "image-upload" }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.image_url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="w-20 h-20 rounded-xl overflow-hidden bg-[#FFF8F0] border border-[#1A1A1A]/10 flex items-center justify-center flex-shrink-0">
        {value ? (
          <img src={resolveImage(value)} alt="preview" className="w-full h-full object-cover" />
        ) : (
          <Upload className="w-6 h-6 text-[#1A1A1A]/30" />
        )}
      </div>
      <div className="flex-1">
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={`${testId}-input`} />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="inline-flex items-center gap-2 rounded-full bg-[#7ED321] hover:bg-[#FF7A1A] text-white font-bold text-sm px-5 py-2.5 transition-colors disabled:opacity-60"
          data-testid={`${testId}-btn`}
        >
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {uploading ? "Uploading…" : value ? "Change photo" : "Upload photo"}
        </button>
      </div>
    </div>
  );
};

export default ImageUpload;
